export default __webpack_public_path__ + "static/assets/im_incoming_restriction.1fd770a47a0ecae0ea05d8f475163bc6.png";